import React, { useEffect, useState } from "react";
import {
    Space,
    Typography,
    Table,
    Tooltip,
} from "antd";
import {
    PlusOutlined,
    EditOutlined,
} from "@ant-design/icons";
import "./ClassManagementOffline.scss";
import { useNavigate } from "react-router-dom";
import ClassManagementFormOffline from "./ClassManagentForm/ClassManagementFormOffline";
import Buttons from "../../Components/Buttons/Buttons";
import Loader from "../../Components/Loader/Loader";
import { getApi } from "../../Utlis/apiService";
import { GET_OFFLINE_CLASS_PRICES } from "../../Utlis/apiPath";
import { errorToast } from "../../Services/ToastHelper";

const { Title } = Typography;

const ClassManagementOffline = () => {
    const [addOfflineClassForm, setAddOfflineClassForm] = useState(false);
    const [editData, setEditData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isOfflineMode, setIsOfflineMode] = useState(true);
    const [hasData, setHasData] = useState(false);

    const navigate = useNavigate();

    const handleClassAction = () => {
        // if a row already exists pick the first one – there are only two rows max
        if (hasData && tableData.length) {
            const row = tableData[0]; // first row holds the pricing object
            setEditData({
                id: row.key,
                customPerClassPrice: row.price,
                compareCustomPerClassPrice: row.compareAtPrice,
                alternateMonthlyPrice: row.alternateMonthlyPrice,
                compareAlternateMonthlyPrice: row.alternateMonthlyCompareAtPrice,
            });
        } else {
            setEditData(null); // "Add" mode
        }
        setAddOfflineClassForm(true);
    };

    const columns = [
        {
            title: "SL No",
            key: "slNo",
            width: "20%", // Equal width distribution
            render: (text, record, index) => index + 1,
        },
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            width: "20%", // Equal width instead of fixed 200px
            render: (title) => {
                const shouldTruncate = title && title.length > 20;
                const displayText = shouldTruncate ? `${title.slice(0, 20)}...` : title;

                return shouldTruncate ? (
                    <Tooltip title={title}>
                        <span>{displayText}</span>
                    </Tooltip>
                ) : (
                    <span>{title || 'N/A'}</span>
                );
            },
        },
        {
            title: "Price (₹)",
            dataIndex: "price",
            key: "price",
            width: "20%", // Equal width distribution
            render: (price) => price ? `₹${price}` : 'N/A',
        },
        {
            title: "Compare At Price (₹)",
            dataIndex: "compareAtPrice",
            key: "compareAtPrice",
            width: "20%", // Equal width distribution
            render: (compareAtPrice) => compareAtPrice ? `₹${compareAtPrice}` : 'N/A',
        },
        {
            title: "Created Date",
            dataIndex: "createdDate",
            key: "createdDate",
            width: "20%", // Equal width distribution
            render: (createdDate) => {
                if (createdDate) {
                    return new Date(createdDate).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                }
                return 'N/A';
            },
        },
    ];


    useEffect(() => {
        fetchAllOfflineClasses();
    }, []);

    const fetchAllOfflineClasses = async () => {
        setIsLoading(true);
        try {
            const { status, data } = await getApi(GET_OFFLINE_CLASS_PRICES);

            if (status === 200 && data && data.length > 0) {
                const transformedData = data.map((item, index) => ({
                    key: item.id || index,
                    title: item.title,
                    price: item.price,
                    compareAtPrice: item.comparePrice,
                    alternateMonthlyPrice: item.alternateMonthlyPrice,
                    alternateMonthlyCompareAtPrice: item.alternateMonthlyCompareAtPrice,
                    createdDate: item.createdDate || item.created_at || item.createdAt || null,
                }));

                setTableData(transformedData);
                setHasData(true);
            } else {
                setTableData([]);
                setHasData(false);
            }
        } catch (error) {
            console.error("Error fetching offline classes:", error);
            errorToast("Failed to fetch offline classes");
            setTableData([]);
            setHasData(false);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            {isLoading && <Loader />}
            {!addOfflineClassForm && (
                <div className="headers">
                    <Space
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                        }}
                        size="large"
                    >
                        <Title level={3} style={{ margin: 0 }}>
                            Offline Classes Management
                        </Title>
                           <div className="tab-navigation">
                                <button
                                    className={`tab-button ${!isOfflineMode ? "active" : ""}`}
                                    onClick={() => {
                                        setIsOfflineMode(false);
                                        navigate('/standard-class');
                                    }}
                                >
                                    Online
                                </button>
                                <button
                                    className={`tab-button ${isOfflineMode ? "active" : ""}`}
                                    onClick={() => {
                                        setIsOfflineMode(true);
                                    }}
                                >
                                    Offline
                                </button>
                            </div>
                        <Space>
                         

                            <Buttons variant="primary" onClick={handleClassAction}>
                                {hasData ? <EditOutlined /> : <PlusOutlined />}
                                {hasData ? 'Edit Class' : 'Add Class'}
                            </Buttons>
                        </Space> 
                    </Space>
                </div>
            )}

            <div>
                {addOfflineClassForm ? (
                    <ClassManagementFormOffline
                        setAddOfflineClassForm={setAddOfflineClassForm}
                        fetchAllOfflineClasses={fetchAllOfflineClasses}
                        editData={editData}
                        tableData={tableData} // Pass the table data
                    />
                ) : (
                    <div className="contentWrapper">
                        <div className="table-data">
                            <Table
                                columns={columns}
                                dataSource={tableData}
                                pagination={false}
                                scroll={{ x: "max-content" }}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClassManagementOffline;
